var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DForm',_vm._g({attrs:{"value":_vm.value}},{ ..._vm.$listeners, input: _vm.input }),[_c('DField',_vm._b({key:"date",staticClass:"mb-6 bg-grey"},'DField',_vm.date,false)),_c('DField',_vm._b({key:"build",staticClass:"mb-6"},'DField',_vm.build,false)),_c('DField',_vm._b({key:"description",staticClass:"mb-6"},'DField',_vm.description,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }